export default __webpack_public_path__ + "static/timesheet-a46ac4895e1d7674de8d22c638250576.svg";